import { VehicleStatusEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function vehicleStatusNameFilter(status: VehicleStatusEnum): string {
  switch (status) {
    case VehicleStatusEnum.Available: return i18n.t(LF.Available) as string;
    case VehicleStatusEnum.Busy: return i18n.t(LF.Busy) as string;
    case VehicleStatusEnum.InWorkshop: return i18n.t(LF.InWorkshop) as string;
    case VehicleStatusEnum.ReceivingFromWorkshop: return i18n.t(LF.ReceivingFromWorkshop) as string;
    case VehicleStatusEnum.Theft: return i18n.t(LF.IncidentTypeTheft) as string;
    default: return '';
  }
}
